/* eslint-disable */

import React, { Component } from 'react'

import styles from './Styles/CustomMainNavBarStyle'

import { Image, Text, TouchableOpacity, View, StatusBar, TouchableWithoutFeedback, Keyboard, Dimensions, StyleSheet } from 'react-native'
import { Images, Fonts } from '../Themes'



import { SvgBackButton, SvgClose, SvgBlueBarCoder } from './SvgComponent/';

const { width, height } = Dimensions.get("window")

const customMainNavBarStylesStatusBar = StyleSheet.flatten(styles.statusBar)
const customMainNavBarStylesContent = StyleSheet.flatten(styles.content)
const navAndStatusHeight = customMainNavBarStylesContent.height +  customMainNavBarStylesStatusBar.height

export default class CustomMainNavBar extends Component {


  checkTypeImage = (type, transparent) => {

    switch (type) {
      case 'close':
        return Images.crossNav

      case 'profile':
        return Images.profiles

      case 'settings':
        return Images.settings

      case 'hamburger':
        return transparent ? Images.menuIconWhite : Images.menuIcon

      case 'grid':
        return transparent ? Images.gridWhite : Images.grid

      case 'list':
        return transparent ? Images.listWhite : Images.list

      case 'mosaic':
        return transparent ? Images.mosaicWhite : Images.mosaic

      case 'home':
        return Images.homeIcon

      case 'explora':
        return transparent ? Images.exploraIconWhite : Images.exploraIcon

      case 'barcode':
         return transparent ? Images.qrCodeIcon : Images.qrCodeIcon

      case 'happening':
        const { unreadHappening = false } = this.props
        if (unreadHappening)
          return transparent ? Images.heartWallWhiteSolid : Images.heartWallSolid
        else
          return transparent ? Images.heartWallWhite : Images.heartWall

      default:
        break;
    }
  }

  renderButton = (type, onPress, transparent, style) => {
    return (
      <TouchableOpacity onPress={onPress} style={style}>
        {type === 'back' && <SvgBackButton />}
        {type === 'closeBlue' && <SvgClose size="30" />}
        {type !== 'barcode' && type !== 'back' && type !== 'closeBlue'  && <Image style={transparent ? styles.imageWhite : styles.image} source={this.checkTypeImage(type, transparent)} />}
        {type === 'barcode' && <SvgBlueBarCoder size="30"/> }
      </TouchableOpacity>
    )
  }

  renderTitle = (title, online, onTitlePress, transparent) => {
//           <Image style={styles.onlineImage} source={Images.online} />
    if (title) {
      if (online === true) {
        return (
          <TouchableOpacity key={`title`} style={styles.online} onPress={onTitlePress}>
            <View key={`title_online`} style={styles.userOnline}></View>
            <Text key={`title_text`} style={[styles.titleBlack]}>{title}</Text>
          </TouchableOpacity>)
      }
      else if (online === false)
        return (
          <TouchableOpacity key={`title`} style={styles.online} onPress={onTitlePress}>
            <View key={`title_offline`} style={styles.userOffline}></View>
            <Text key={`title_text`} style={[styles.titleBlack]}>{title}</Text>
          </TouchableOpacity>)
      else
        return (
          <TouchableOpacity key={`title`} style={styles.titleWrapper} onPress={onTitlePress}>
            <Text key={`title_text`} style={styles.titleBlack}>{title}</Text>
          </TouchableOpacity>)
    }
/*
<Text key={`title_text`} style={[styles.titleBlack, { alignSelf: 'center' }]}>{title}</Text>
logo: {
  alignSelf: 'center',
  height : 30 ,
  width: 120,
  marginTop: 5
},
*/
    const extraTitleWrapper = {
      // backgroundColor: '#ff6666', // ff6666
      height: 44,
    }
    const extraImageStyle = {
      height: 44,
      width: 110,
      marginTop: 0,
    }
    return (
      <TouchableOpacity key={`title`} style={[styles.titleWrapper, extraTitleWrapper]} onPress={onTitlePress}>
        <Image key={`title_image`} source={transparent ? Images.kargoeLogoHomeWhite : Images.kargoeLogoHome} resizeMode="contain" style={[styles.logo, extraImageStyle]} onPress={onTitlePress} />
      </TouchableOpacity>)
  }

  renderMainPageNav() {
    const { leftButtonTitle, rightButtonTitle, rightButtonInnerTitle = 'explora', title, online, onTitlePress, onLeftPress, onRightPress, onRightInnerPress, transparent = false } = this.props
    const panelColour = transparent ? 'transparent' : 'rgba(255, 255, 255, 0.80)'
    const extraStyle = { backgroundColor: panelColour, borderBottomColor: 'transparent' }
    // console.tron.log(`renderMainPageNav, transparent: ${transparent}, rightButtonTitle: ${rightButtonTitle}`)
    const navWrapperStyle = {
      zIndex: 10000,
      position: 'absolute',
      top: 0,
      height: customMainNavBarStylesStatusBar.height + 44,
      backgroundColor: 'transparent' // transparent ? 'transparent' : 'white' // 'rgba(255, 255, 255, 0.80)'
    }
    const titleGraphicWidth = 104 // 110
    const extraTitleWrapper = {
      zIndex: 10001,
      position: 'absolute',
      top: customMainNavBarStylesStatusBar.height + 5,
      left: (width - titleGraphicWidth) / 2,
      height: 44,
      width: titleGraphicWidth,
    }
    const extraImageStyle = {
      height: 44,
      width: titleGraphicWidth,
      marginTop: 0,
    }
    const leftButtonStyle = {
      zIndex: 10002,
      position: 'absolute',
      top: customMainNavBarStylesStatusBar.height,
      left: 0,
      width: 44,
      height: 44,
      paddingTop: 6, // 6, // 14,
      paddingLeft: 7.5,
      paddingRight: 7.5,
      paddingBottom: 9,
    }
    const rightButtonInnerStyle = {
      zIndex: 10003,
      position: 'absolute',
      top: customMainNavBarStylesStatusBar.height,
      left: width - 44 - 44,
      width: 44,
      height: 44,
      paddingTop: 9, // 6, // 14,
      paddingLeft: 16, // 7.5
      paddingRight: 0, // 7.5
      paddingBottom: 6, // 9
    }
    const rightButtonStyle = {
      zIndex: 10003,
      position: 'absolute',
      top: customMainNavBarStylesStatusBar.height,
      left: width - 44,
      width: 44,
      height: 44,
      paddingTop: 6, // 6, // 14,
      paddingLeft: 7.5,
      paddingRight: 7.5,
      paddingBottom: 9,
    }
    const leftRightImageStyle = {
      width: 29,
      height: 29,
    }
    const barCodeImageStyle = {
      width: 24,
      height: 24
    }
    const backgroundView = transparent ? null :
      (
        <View style={{ backgroundColor: 'rgba(255, 255, 255, 0.80)', width: width, height: 44 }}></View>
      )
    const logo = transparent ? Images.kargoeLogoHomeWhite : Images.kargoeLogoHome
    return (
      <View key={`nav_wrapper`} style={navWrapperStyle}>
        <View key={`status_bar`} style={[styles.statusBar, extraStyle]} />
        <StatusBar key={`status_bar2`} translucent barStyle="dark-content" style={{ backgroundColor: panelColour }} />

        {backgroundView}

        <TouchableOpacity key={`left_button`} style={leftButtonStyle} onPress={onLeftPress}>
          <Image style={leftRightImageStyle} source={this.checkTypeImage(leftButtonTitle, transparent)} />
        </TouchableOpacity>

        <TouchableOpacity key={`title`} style={[styles.titleWrapper, extraTitleWrapper]} onPress={onTitlePress}>
          <Image key={`title_image`} source={logo} resizeMode="contain" style={[styles.logo, extraImageStyle]} onPress={onTitlePress} />
        </TouchableOpacity>

        <TouchableOpacity key={`right_button_inner`} style={rightButtonInnerStyle} onPress={onRightInnerPress}>
          {/*<Image style={leftRightImageStyle} source={this.checkTypeImage(rightButtonInnerTitle, transparent)} />*/}
          {/*< SvgBlueBarCoder size="30"/>  leftRightImageStyle */}
          <Image source={Images.barCodeIcon} style={barCodeImageStyle}/>
          { /* <SvgBlueBarCoder size="24"/> */ }
        </TouchableOpacity>

        <TouchableOpacity key={`right_button`} style={rightButtonStyle} onPress={onRightPress}>
          <Image style={leftRightImageStyle} source={this.checkTypeImage(rightButtonTitle, transparent)} />
        </TouchableOpacity>
      </View>
    )
  } // renderMainPageNav

  render() {
    const { leftButtonTitle, rightButtonInnerTitle, rightButtonTitle, title, online, onTitlePress, onLeftPress, onRightPress, transparent = false, isHomeScreen = false } = this.props
    const extraStyle = { backgroundColor: 'transparent', borderBottomColor: 'transparent' }
    // console.tron.log(`CustomMainNavBar render leftButtonTitle: ${leftButtonTitle}, rightButtonTitle: ${rightButtonTitle}`)
    if (isHomeScreen) // title == '' && transparent) // Kargoe, transparent
      return this.renderMainPageNav()
    else
      return (
        <View key={`nav_wrapper`}
          style={[
            styles.container,
            styles.navbar,
            transparent ? { backgroundColor: 'transparent', position: 'absolute', top: styles.statusBar.height, left: 0, width: width } : {}
          ]}>
          <View key={`nav_header`}>
            <View key={`status_bar`} style={[styles.statusBar, extraStyle]} />
            <StatusBar key={`status_bar2`} translucent barStyle="dark-content" style={{ backgroundColor: transparent ? 'transparent' : '#FFFFFF' }} />
            <View key={`buttons_and_title`} style={[styles.content, extraStyle]}>
              <View key={`left_button`} style={styles.leftButtons}>
                <TouchableOpacity onPress={onLeftPress} style={styles.button}>
                  {leftButtonTitle === 'back' && <SvgBackButton />}
                  {leftButtonTitle === 'closeBlue' && <SvgClose size="20" />}
                  {leftButtonTitle !== 'back' &&  leftButtonTitle !== 'closeBlue' && <Image style={transparent ? styles.imageWhite : styles.image} source={this.checkTypeImage(leftButtonTitle, transparent)} />}
                </TouchableOpacity>
              </View>
              {this.renderTitle(title, online, onTitlePress, transparent)}
              <View key={`right_button`} style={styles.rightButtons}>
                {!!rightButtonTitle &&
                  this.renderButton(rightButtonTitle, onRightPress, transparent, styles.button)}
              </View>
            </View>
          </View>
        </View>
      )
  }
}
